import { render, staticRenderFns } from "./EditInfoCard.vue?vue&type=template&id=3e425b79&"
import script from "./EditInfoCard.vue?vue&type=script&lang=js&"
export * from "./EditInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports